import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import './index.css'
import './styles/settings.css'
import './styles/light-theme-overrides.css'
import './lib/clearOrganizationLocks' // Make utility available globally
import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext'
import { OrganizationProvider } from './contexts/OrganizationContext'
import { BrandingProvider, BrandingStyleInjector } from './contexts/BrandingContext'
import { CartProvider } from './contexts/CartContext'
import { PersonalSetupProvider } from './contexts/PersonalSetupContext'
import { queryClient } from './lib/react-query'
import { initializeMonitoring } from './lib/monitoring'

const isE2E =
  import.meta.env.VITE_E2E === '1' ||
  import.meta.env.VITE_E2E === 'true' ||
  (typeof navigator !== 'undefined' && navigator.webdriver === true) ||
  (() => {
    try {
      return window.localStorage.getItem('E2E_MODE') === '1'
    } catch {
      return false
    }
  })()

if (isE2E) {
  document.documentElement.setAttribute('data-e2e', '1')
}

// Initialize Sentry error monitoring before React starts
initializeMonitoring()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <OrganizationProvider>
          <BrandingProvider>
            <CartProvider>
              <PersonalSetupProvider>
                <BrandingStyleInjector />
                <App />
              </PersonalSetupProvider>
            </CartProvider>
          </BrandingProvider>
        </OrganizationProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
